import { startsWith } from 'es-toolkit/compat';
import superagent from 'superagent';

declare global {
  // Allows runtime override of the API host (set from Cypress before app bootstrap).
  // eslint-disable-next-line vars-on-top, no-var, @typescript-eslint/naming-convention
  var __API_HOST__: string | undefined;
}

declare const API_HOST: string;

export const resolveApiHost = () => {
  if (typeof window !== 'undefined' && window.__API_HOST__) {
    return window.__API_HOST__;
  }

  return API_HOST;
};

const apiUtils = {
  request({
    method,
    url,
    data = null,
    accessToken = null,
    signal = null,
    mediaType = 'application/json',
    responseType = null,
  }: {
    method: string;
    url: string;
    data: any;
    accessToken?: string | null;
    signal?: AbortSignal | null;
    mediaType?: string;
    responseType?: string | null;
  }) {
    const request = superagent(method, `${resolveApiHost()}/${url}`).set('Accept', mediaType);
    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;

    if (data) {
      if (method.toUpperCase() === 'GET') {
        request.query(data);
      } else if (isFormData) {
        request.send(data);
      } else {
        request.send(data).set('Content-Type', 'application/json');
      }
    }
    const headers = accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
    request.set(headers);

    if (signal) {
      signal?.addEventListener('abort', () => {
        request.abort();
      });
    }

    if (responseType) {
      return request.responseType(responseType).then((responseData) => responseData);
    }

    return request.then((responseData) => responseData); // force request to be sent
  },
};

export const getOneIndexedPageWithOffset = (page: number, offset: number, totalPages: number) => {
  const zeroIndexedPage = page - 1;
  const zeroIndexedPageWithOffset = (zeroIndexedPage + offset + totalPages) % totalPages;
  return zeroIndexedPageWithOffset + 1;
};

export const isNotPresignedUrl = (url: string) => startsWith(url, 's3://');

export default apiUtils;
